import { Avatar } from '../../../../utils/avatar';
import { formatearFechaCompleta, formatearFechaCorta } from '../../../../utils/utils'
import React, { useState, useEffect, useMemo } from 'react';

export const Badge = ({ text, color = 'blue' }) => {
    const colorClasses = {
        blue: 'bg-blue-100 text-blue-800',
        green: 'bg-green-100 text-green-800',
        yellow: 'bg-yellow-100 text-yellow-800',
    };
    return (
        <span className={`px-2 py-0.5 text-[10px] font-semibold rounded-full ${colorClasses[color]}`}>
            {text.toUpperCase()}
        </span>
    );
};

const UserCard = ({ chat, chatActivoId, onSetActivo, idChatActualizado, onContextMenu }) => {
  // Verificamos si este card es el que está activo
  const esActivo = chat.phone_number === chatActivoId;
  const esRecienActualizado = chat.phone_number === idChatActualizado;
  const isClienteProspecto = chat.clienteInfo.nombrecompletoCliente != "PROSPECTO CLIENTE";

  const cardClasses = `
    flex items-center p-3 cursor-pointer transition-all duration-200 ease-in-out border-b border-gray-200
    ${esActivo ? 'bg-sky-100' : 'hover:bg-gray-100'}
    ${esRecienActualizado ? 'animate-flash' : ''} // <-- Esta clase ahora viene de tu config
  `;

  //logica para vencimiento
  const ahora = new Date();
  const fechaVencimiento = new Date(chat.session_expires_at);
  const { vencida, texto } = useCountdown(chat.session_expires_at);


  // Al hacer clic, pasamos el phone_number
  const handleSelectChat = () => {
    onSetActivo(chat.phone_number); // <-- CORRECCIÓN #1: Usar phone_number en lugar de id
  };

  const handleRightClick = (event) => {
    // Llama a la función del padre pasándole el evento y el ID del chat
    onContextMenu(event, chat.phone_number);
  };

  return (
    // CONTENEDOR PRINCIPAL
    <div
      key={chat.phone_number}
      className="flex items-center p-3 gap-3 cursor-pointer hover:bg-gray-100 transition-colors duration-150 border-b border-gray-100"
      onClick={handleSelectChat}
      onContextMenu={handleRightClick}
    >
      {/* --- AVATAR --- */}
      <div className="flex-shrink-0">
        <Avatar name={chat.name} />
      </div>

      {/* --- CONTENIDO CENTRAL (NOMBRE, NÚMERO, MENSAJE) --- */}
      <div className="flex-grow min-w-0">
        
        {/* Fila superior: Nombre y Hora del último mensaje */}
        <div className="flex justify-between items-center">
          <p className="font-semibold text-gray-800 truncate">
            {isClienteProspecto ? chat.name : chat.clienteInfo.nombreCliente}
          </p>

          {/* --- LÍNEA MODIFICADA AQUÍ --- */}
          <span className="text-sm font-medium text-gray-600 flex-shrink-0 ml-2">
            {formatearFechaAvanzada(chat.last_message_timestamp)}
          </span>
          
        </div>
        
        {/* Fila intermedia: Número de teléfono y Badges */}
        <div className="flex items-center gap-2 text-xs text-gray-500">
           <span>{chat.phone_number}</span>
           {chat.label && <Badge text={chat.label} color="blue" />}
        </div>

        archi {chat.archivo}
        pwg {chat.source_type  } - fir {chat.clienteInfo.SourceType} 
        
        {/* Fila inferior: Preview de mensaje y Contador de no leídos */}
        <div className="flex justify-between items-center mt-0.5">
          <div className="flex items-center text-sm truncate text-gray-500 min-w-0">
            {(chat.source_type === 'ad' || chat.clienteInfo.SourceType === 'ad' ) && (
              <span className="mr-1.5 px-1 py-0.5 bg-green-500 text-white text-[9px] font-bold rounded">AD</span>
            )}
            {!chat.last_message_is_from_user && (
              <span className="font-semibold mr-1">Tú:</span>
            )}
            <p className="truncate">
              {chat.last_message_preview || "No hay mensajes recientes"}
            </p>
          </div>
          
          {chat.unread_messages_count > 0 && (
            <span className="bg-sky-500 text-white text-[10px] font-bold w-5 h-5 flex items-center justify-center rounded-full flex-shrink-0 ml-2">
              {chat.unread_messages_count}
            </span>
          )}
        </div>

        {vencida ? (
          <Badge text="Vencida" color="red" />
        ) : (
          <Badge text={`Activa (${texto})`} color="green" />
        )}
        
      </div>
    </div>
  );
  
};

const formatearFechaAvanzada = (timestamp) => {
  if (!timestamp) return '';

  const ahora = new Date();
  const fechaMensaje = new Date(timestamp);

  const esHoy = ahora.toDateString() === fechaMensaje.toDateString();
  const fueAyer = new Date(ahora.setDate(ahora.getDate() - 1)).toDateString() === fechaMensaje.toDateString();

  if (esHoy) {
    // Si es hoy, muestra la hora: "11:20 AM"
    return fechaMensaje.toLocaleTimeString('es-CO', { hour: 'numeric', minute: '2-digit', hour12: true });
  } else if (fueAyer) {
    // Si fue ayer, muestra "Ayer"
    return 'Ayer';
  } else {
    // Si es más antiguo, muestra la fecha corta: "08/09/2025"
    return fechaMensaje.toLocaleDateString('es-CO', { day: '2-digit', month: '2-digit', year: 'numeric' });
  }
};

const calcularTiempoRestante = (fechaExpiracion) => {
    const ahora = new Date();
    const expiracion = new Date(fechaExpiracion);
    const totalSegundos = Math.floor((expiracion - ahora) / 1000);

    if (totalSegundos <= 0) {
        return { vencida: true, texto: '0s' };
    }

    const horas = Math.floor(totalSegundos / 3600);
    const minutos = Math.floor((totalSegundos % 3600) / 60);
    const segundos = totalSegundos % 60;

    if (horas > 0) {
        return { vencida: false, texto: `${horas}h ${minutos}m` };
    }
    if (minutos > 0) {
        return { vencida: false, texto: `${minutos}m ${segundos}s` };
    }
    return { vencida: false, texto: `${segundos}s` };
};

export const useCountdown = (fechaExpiracion) => {
    const [tiempo, setTiempo] = useState(() => calcularTiempoRestante(fechaExpiracion));

    useEffect(() => {
        // Actualiza el contador cada segundo
        const intervalId = setInterval(() => {
            setTiempo(calcularTiempoRestante(fechaExpiracion));
        }, 1000);

        // Limpia el intervalo cuando el componente se desmonta para evitar fugas de memoria
        return () => clearInterval(intervalId);
    }, [fechaExpiracion]);

    return tiempo;
};


export default UserCard
